import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import Swal from "sweetalert2";

@Component({
  selector: 'app-animate',
  templateUrl: './animate.component.html',
  styleUrls: ['./animate.component.scss']
})
export class AnimateComponent implements OnInit {

  constructor(private router: Router) { }
  data:any;
  mute=true;
  unmute=false;
    // loginVideo=true;
  ngOnInit(): void {
    // const epochToday = (new Date).getDate();
    localStorage.setItem('205130','85');
    localStorage.setItem('205128','101');

 
  }
  endVideo(){
    let start = Date.now();
    // console.log(epochToday);
    // alert(start)
    if (start >=  1650340800000 && start <= 1650342600000) {
      this.router.navigate(['/auditorium/stage/205219']);
      this.data = JSON.parse(localStorage.getItem('virtual')).name;
    function speak2(text) {
      var utterance = new SpeechSynthesisUtterance();
      utterance.text = text;
      utterance.lang = "en-US";

      utterance.rate = 1;

      speechSynthesis.speak(utterance);
    }
    speak2('Welcome '+this.data);
    
    } else {
      this.router.navigate(['/lobby']);
      this.data = JSON.parse(localStorage.getItem('virtual')).name;
      function speak2(text) {
      var utterance = new SpeechSynthesisUtterance();
      utterance.text = text;
      utterance.lang = "en-US";

      utterance.rate = 1;

      speechSynthesis.speak(utterance);
    }
    
    speak2('Welcome '+this.data);
    const Toast = Swal.mixin({
      toast: true,
      position: "top",
      showConfirmButton: false,
      timer: 10000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.addEventListener("mouseenter", Swal.stopTimer);
        toast.addEventListener("mouseleave", Swal.resumeTimer);
      },
    });

    Toast.fire({
      icon: 'success',
      title: 'Welcome '+this.data
    })
    }

    
    
  }
  skip(){
    let vid: any = document.getElementById('loginVideo');
    vid.pause();
    vid.currentActiveTime = 0;

    let start = Date.now();
    // alert(start)
    if (start >  1650340800000 && start <= 1650342600000) {
      this.router.navigate(['/auditorium/stage/205219']);
      this.data = JSON.parse(localStorage.getItem('virtual')).name;
  
      function speak2(text) {
        var utterance = new SpeechSynthesisUtterance();
        utterance.text = text;
        utterance.lang = "en-US";
  
        utterance.rate = 1;
  
        speechSynthesis.speak(utterance);
      }
      speak2('Welcome '+this.data);
    }else{
      this.router.navigate(['/lobby']);
      this.data = JSON.parse(localStorage.getItem('virtual')).name;
  
      function speak2(text) {
        var utterance = new SpeechSynthesisUtterance();
        utterance.text = text;
        utterance.lang = "en-US";
  
        utterance.rate = 1;
  
        speechSynthesis.speak(utterance);
      }
      speak2('Welcome '+this.data);
      const Toast = Swal.mixin({
        toast: true,
        position: "top",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        iconColor:'#fff',
        background:'#1c1c38',
        // color:'#fff',
        
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", Swal.stopTimer);
          toast.addEventListener("mouseleave", Swal.resumeTimer);
        },
      });
  
      Toast.fire({
        icon: 'success',
        title: 'Welcome '+this.data
      })
    }
    
  }

  muteButton(){
    this.mute=false;
    this.unmute=true;
    let main: any = document.getElementById("loginVideo");
    main.muted = true;
  }
  unmuteButton(){
    this.mute=true;
    this.unmute=false;
    let main: any = document.getElementById("loginVideo");
    main.muted = false;
  }

}
